var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen"},[(_vm.isLoading)?_c('loading-screen'):_c('div',{staticClass:"h-full"},[(_vm.msTeamsAppInitialized)?_c('router-view'):_c('div',[_vm._v("\n      "+_vm._s(_vm.$i18nPresenter.t("This route only supported in Microsoft Teams"))+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }